export const cargoQuantity = [
    {
        id: '1-100吨',
        title: '1-100吨'
    },
    {
        id: '100-200吨',
        title: '100-200吨'
    },
    {
        id: '200-300吨',
        title: '200-300吨'
    },
    {
        id: '300-400吨',
        title: '300-400吨'
    },
    {
        id: '400-500吨',
        title: '400-500吨'
    },
    {
        id: '500-600吨',
        title: '500-600吨'
    },
    {
        id: '600-700吨',
        title: '600-700吨'
    },
    {
        id: '700-800吨',
        title: '700-800吨'
    },
    {
        id: '800-900吨',
        title: '800-900吨'
    },
    {
        id: '900-1000吨',
        title: '900-1000吨'
    },
    {
        id: '大于1000吨',
        title: '大于1000吨'
    },

]